import { useAppSelector } from './useRedux';
import { useSlice } from './useSlice';
import { selectMenu } from '../features/infoSlice';
import { libPageChanged } from '../features/librarySlice';
import { sharePageChanged } from '../features/shareSlice';
import { drivePageChanged } from '../features/driveSlice';
import { searchPageChanged } from '../features/searchSlice';
import { trashPageChanged } from '../features/trashSlice';

import { mainApiSlice } from '../services/main';
import { libApiSlice, selectTotalProjectsNum } from '../services/library';
import { selectTotalSharedNum, shareApiSlice } from '../services/share';
import { driveApiSlice, selectTotalResourceNum } from '../services/drive';
import { searchApiSlice, selectTotalPublicNum } from '../services/search';
import { selectTotalTrashNum, trashApiSlice } from '../services/trash';

export const usePage = () => {
  const menu = useAppSelector(selectMenu);

  const { selectPage } = useSlice();
  const page: number = useAppSelector(selectPage);

  const funcByMenu: { [key: string]: any } = {
    main: {
      initPageList: mainApiSlice.endpoints.getMain.initiate,
    },
    settings: {},
    library: {
      pageChanged: libPageChanged,
      initPageList: libApiSlice.endpoints.getLibrary.initiate,
      totalLen: useAppSelector(selectTotalProjectsNum),
    },
    share: {
      pageChanged: sharePageChanged,
      initPageList: shareApiSlice.endpoints.getSharedLibrary.initiate,
      totalLen: useAppSelector(selectTotalSharedNum),
    },
    mydrive: {
      pageChanged: drivePageChanged,
      initPageList: driveApiSlice.endpoints.getResources.initiate,
      totalLen: useAppSelector(selectTotalResourceNum),
    },
    search: {
      pageChanged: searchPageChanged,
      initPageList: searchApiSlice.endpoints.getPublicList.initiate,
      totalLen: useAppSelector(selectTotalPublicNum),
    },
    trash: {
      pageChanged: trashPageChanged,
      initPageList: trashApiSlice.endpoints.getTrashList.initiate,
      totalLen: useAppSelector(selectTotalTrashNum),
    },
  };

  return {
    page,
    pageChanged: funcByMenu[menu]?.pageChanged,
    initPageList: funcByMenu[menu]?.initPageList,
    totalLen: funcByMenu[menu]?.totalLen,
  };
};
